import { orderService } from './order.service';
import { productService } from './product.service';
import { invoiceService } from './invoice.service';
import { formatPrice } from '@/utils/formatters';

export interface SearchResult {
  type: 'order' | 'product' | 'client' | 'invoice';
  id: number;
  title: string;
  subtitle?: string;
  url: string;
}

export const searchService = {
  /**
   * Recherche globale dans toutes les entités
   */
  async searchAll(query: string): Promise<SearchResult[]> {
    if (!query || query.trim().length < 2) {
      return [];
    }

    const searchTerm = query.trim().toLowerCase();
    const results: SearchResult[] = [];

    try {
      // Recherche dans les commandes
      const orders = await orderService.getAll();
      orders.forEach(order => {
        const orderNumber = order.order_number?.toLowerCase() || '';
        const customerName = order.customer_name?.toLowerCase() || '';
        const customerEmail = order.customer_email?.toLowerCase() || '';
        
        if (orderNumber.includes(searchTerm) || 
            customerName.includes(searchTerm) || 
            customerEmail.includes(searchTerm)) {
          results.push({
            type: 'order',
            id: order.id,
            title: `Commande ${order.order_number}`,
            subtitle: `${order.customer_name} - ${formatPrice(order.total || 0)}`,
            url: `/admin/commandes?search=${encodeURIComponent(query)}`
          });
        }
      });

      // Recherche dans les produits
      const products = await productService.getAll();
      products.forEach(product => {
        const name = product.name?.toLowerCase() || '';
        const sku = product.sku?.toLowerCase() || '';
        const description = product.description?.toLowerCase() || '';
        
        if (name.includes(searchTerm) || 
            sku.includes(searchTerm) || 
            description.includes(searchTerm)) {
          results.push({
            type: 'product',
            id: product.id,
            title: product.name,
            subtitle: `SKU: ${product.sku || 'N/A'} - ${product.price} €`,
            url: `/admin/liste-produits?search=${encodeURIComponent(query)}`
          });
        }
      });

      // Recherche dans les factures
      try {
        const invoices = await invoiceService.getAll();
        invoices.forEach(invoice => {
          const invoiceNumber = invoice.invoice_number?.toLowerCase() || '';
          const customerName = invoice.customer_name?.toLowerCase() || '';
          
          if (invoiceNumber.includes(searchTerm) || 
              customerName.includes(searchTerm)) {
            results.push({
              type: 'invoice',
              id: invoice.id,
              title: `Facture ${invoice.invoice_number}`,
              subtitle: `${invoice.customer_name} - ${formatPrice(invoice.total_amount || 0)}`,
              url: `/admin/factures?search=${encodeURIComponent(query)}`
            });
          }
        });
      } catch (error) {
        console.warn('Erreur lors de la recherche dans les factures:', error);
      }

      // Limiter à 20 résultats maximum
      return results.slice(0, 20);
    } catch (error) {
      console.error('Erreur lors de la recherche globale:', error);
      return [];
    }
  }
};
